import React, { useEffect } from "react";
import { Routes } from "./routes";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback, LoadingScreen } from "./components";
import { queryClient } from "./react-query";
import { QueryClientProvider } from "react-query";
import { useStoreState } from "./store/easy-peasy/hooks";
import { ToastContainer } from 'react-toastify';
import { handleUrlParams } from "./utils";
import { setStorage } from "./services/storageService";

function App() {
  let isAuthenticated = useStoreState((store) => store.isAuthenticated);

  const { clientId, uinIds } = handleUrlParams();

  // Run on component mount to handle URL parameters
  useEffect(() => {
    // Ensure storage is updated with the latest values
    if (clientId) {
      setStorage('client_id', clientId);
    }
    
    if (uinIds) {
      setStorage('uin_ids', JSON.stringify(uinIds));
    }
  }, [clientId, uinIds]);

  return (
    <ErrorBoundary
      fallback={<ErrorFallback />}
      onReset={() => {
        // Reset the state of your app so the error doesn't happen again
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Routes isAuthorized={isAuthenticated} />
        <ToastContainer />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
